module.exports = __webpack_public_path__ + "img/2.4c22bc5c.jpeg";